import {UnorderedListContent} from "../../../common/types/post.types";

function UnorderedList(props: Props) {
  const {title, list} = props.data.content;

  return (
    <div className={'unordered-list'}>
      {title ? <div className={'title'}>{title}</div> : ''}
      <ul>
        {list.map((item, index) => <li className={'item'} key={index}>{item}</li>)}
      </ul>
    </div>
  )
}

export default UnorderedList;

class Props {
  data: UnorderedListContent;
}
